import RemoveContact from '@/components/features/contacts/remove';
import UpdateContact from '@/components/features/contacts/update';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { ROUTES_CONFIG } from '@/config/routes.config';
import { useTRPC } from '@/trpc'
import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as Icons from 'lucide-react'
import { Link } from 'react-router-dom';

const OverviewTable = () => {
    const { trpc } = useTRPC();
    const queryClient = useQueryClient();

    const { data:contacts } = useQuery({
        queryKey: ['contacts'],
        queryFn: async () => {
            const contacts = await trpc.contacts.search.query({})
            return contacts;
        }
    })

  return (
    <div className="h-full overflow-auto">
        <div className="bg-foreground/10 rounded-md border p-2 overflow-auto h-full">
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Naam</TableHead>
                        <TableHead>Bedrijfsnaam</TableHead>
                        <TableHead>Email</TableHead>
                        <TableHead>Telefoon</TableHead>
                        <TableHead>Contact via</TableHead>
                        <TableHead>Notitie</TableHead>
                        <TableHead>Betrouwbaarheid</TableHead>
                        <TableHead>Kwaliteit spelers</TableHead>
                        <TableHead></TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {contacts?.map((contact)=>(
                        <TableRow>
                            <TableCell className='p-0'>
                                <Link to={ROUTES_CONFIG.APP.CONTACTS.DETAIL.$buildPath({ params:{ contact_id:contact.id } })} className='hover:underline font-medium p-2'>
                                    {contact?.contact_name}
                                </Link>
                            </TableCell>
                            <TableCell>{contact?.company_name}</TableCell>
                            <TableCell>{contact?.email}</TableCell>
                            <TableCell>{contact?.telephone}</TableCell>
                            <TableCell>{contact?.contact_via?.join(', ')}</TableCell>
                            <TableCell>{contact?.note}</TableCell>
                            <TableCell>{contact?.reliability}</TableCell>
                            <TableCell>{contact?.quality_players}</TableCell>
                            <TableCell>
                                <div className="flex items-center justify-end">
                                    <DropdownMenu>
                                        <DropdownMenuTrigger>
                                            <Icons.MoreVertical className="w-4 h-4" />
                                        </DropdownMenuTrigger>
                                        <DropdownMenuContent>
                                            <UpdateContact 
                                                contact_id={contact.id}
                                                defaultValues={{
                                                    contact_name: contact?.contact_name ?? undefined,
                                                    email: contact?.email ?? undefined,
                                                    telephone: contact?.telephone ?? undefined,
                                                    contact_via: contact?.contact_via ?? undefined,
                                                    note: contact?.note ?? undefined,
                                                    reliability: contact?.reliability ?? undefined,
                                                    quality_players: contact?.quality_players ?? undefined,
                                                    company_name: contact?.company_name ?? undefined,
                                                }}
                                                trigger={
                                                    <DropdownMenuItem onSelect={(e)=>e.preventDefault()}>
                                                        <Icons.Edit className="w-4 h-4" />
                                                        Bewerken
                                                    </DropdownMenuItem>
                                                }
                                                onUpdated={()=>{
                                                    queryClient.invalidateQueries({ queryKey: ['contacts'] });
                                                }}
                                            />
                                            <RemoveContact 
                                                onRemoved={()=>{
                                                    queryClient.invalidateQueries({ queryKey: ['contacts'] });
                                                }}
                                                contact_id={contact.id}
                                                trigger={
                                                    <DropdownMenuItem onSelect={(e)=>e.preventDefault()} className='text-destructive hover:!text-destructive/80'>
                                                        <Icons.Trash className="w-4 h-4 text-destructive" />
                                                        Verwijderen
                                                    </DropdownMenuItem>
                                                }
                                            />
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    </div>
  )
}

export default OverviewTable